module.exports = __webpack_public_path__ + "static/img/icon_qrcode.2469b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_qrcode.png
// module id = IfFH
// module chunks = 8